import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check, ArrowRight, ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section className="py-24 bg-[#0a0f1e] relative overflow-hidden" id="oferta" data-id="element-87">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-4xl pointer-events-none" data-id="element-88">
        <div className="absolute inset-0 bg-[#25D366] opacity-5 blur-[150px] rounded-full" data-id="element-89" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-90">
        <div className="max-w-4xl mx-auto bg-[#0f1629] border border-slate-800 rounded-3xl overflow-hidden shadow-2xl" data-id="element-91">
          <div className="grid md:grid-cols-2" data-id="element-92">
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-93">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-94">
                La Promesa de Paz Mental
              </h3>
              <p className="text-slate-400 mb-6" data-id="element-95">
                Imagina despertar mañana, abrir tu calendario y ver que todas
                tus citas de la semana ya han sido confirmadas por tu bot.
              </p>
              <p className="text-slate-400 mb-8" data-id="element-96">
                Contratar a una agencia para configurar esto te costaría al
                menos <span className="text-white font-bold" data-id="element-97">$1,500 USD</span>.
                Hoy lo obtienes por el precio de una cena.
              </p>

              <div className="space-y-3 mb-8" data-id="element-98">
                <div className="flex items-center gap-2 text-slate-300" data-id="element-99">
                  <Check className="h-5 w-5 text-[#25D366]" data-id="element-100" />
                  <span data-id="element-101">Guía paso a paso en PDF</span>
                </div>
                <div className="flex items-center gap-2 text-slate-300" data-id="element-102">
                  <Check className="h-5 w-5 text-[#25D366]" data-id="element-103" />
                  <span data-id="element-104">Scripts de ventas probados</span>
                </div>
                <div className="flex items-center gap-2 text-slate-300" data-id="element-105">
                  <Check className="h-5 w-5 text-[#25D366]" data-id="element-106" />
                  <span data-id="element-107">Diagramas de flujo visuales</span>
                </div>
              </div>
            </div>

            <div id="oferta" className="bg-slate-900/50 p-8 md:p-12 flex flex-col items-center justify-center text-center border-l border-slate-800" data-id="element-108">
              <span className="text-slate-400 text-sm uppercase tracking-wider mb-2" data-id="element-109">
                Oferta Especial
              </span>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-110">
                <span className="text-2xl text-slate-500 line-through" data-id="element-111">
                  $197
                </span>
                <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-112">
                  -70% OFF
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-113">
                <span className="text-5xl font-bold text-white" data-id="element-114">$59</span>
                <span className="text-xl text-slate-500" data-id="element-115">USD</span>
              </div>

              <Button size="lg" className="w-full text-lg mb-4 group animate-pulse hover:animate-none" asChild data-id="element-116">
                <a href="https://mdbhorizonte.com/cart/52033881440548:1" target="_blank" rel="noopener noreferrer" data-id="element-117">
                  DESCARGAR AHORA
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-118" />
                </a>
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-119">
                <ShieldCheck className="h-4 w-4" data-id="element-120" />
                <span data-id="element-121">Pago 100% Seguro</span>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-16 max-w-2xl mx-auto" data-id="element-122">
          <h4 className="text-xl font-bold text-white mb-4" data-id="element-123">
            No dejes que tu competencia automatice primero
          </h4>
          <p className="text-slate-400" data-id="element-124">
            Mientras ellos siguen llamando y dejando mensajes de voz, tú estarás
            cerrando confirmaciones en silencio.
          </p>
        </div>
      </div>
    </section>;
}